import { resolvePriceLabel } from '@/helpers/assetHelper';

type ClassPriceShape = {
  price?: unknown;
  priceLabel?: string | null;
};

export function normalizeClassPrice<T extends ClassPriceShape>(classData: T): T {
  if (!classData || typeof classData !== 'object') {
    return classData;
  }

  const price = classData.price && typeof classData.price === 'object'
    ? { ...classData.price }
    : classData.price;

  const priceLabel = resolvePriceLabel(price, classData.priceLabel || null);

  const normalized: T = {
    ...classData,
    price,
    priceLabel: priceLabel || classData.priceLabel || null,
  };

  if (priceLabel && price && typeof price === 'object' && !(price as { grossAmountStr?: string }).grossAmountStr) {
    normalized.price = {
      ...(price as Record<string, unknown>),
      grossAmountStr: priceLabel,
    };
  }

  return normalized;
}
